import React from "react";
import NotFoundBlock from "../components/NotFoundBlock";

export default function NotFound() {
  return <NotFoundBlock />;
}
